export default "__VITE_ASSET__DfZGKCPC__"